import { createAsyncThunk } from '@reduxjs/toolkit';

import { uploadImage } from '../api/upload';
import { TRootState } from '../reducers';
import { IAttachment } from '../reducers/types';

export const loadAttaches = createAsyncThunk<
  IAttachment[],
  File[],
  { state: TRootState }
>('loadAttaches', async (newAttaches, { rejectWithValue }) => {
  try {
    const attaches = await uploadImage(newAttaches);

    return attaches;
  } catch (err) {
    return rejectWithValue('attach_error');
  }
});
